module.exports = __webpack_public_path__ + "img/x1.5ef8a6b6.jpg";